module.exports = __webpack_public_path__ + "static/media/habits.301bf3fc.svg";